export default __webpack_public_path__ + "static/media/slider4.db94a7ee.jpg";